export default __webpack_public_path__ + "static/media/vdalavora.60f98ec6.png";